<template>
	<el-dialog title="我的考勤" :visible="visible" width="560px" :close-on-click-modal="false"
		@close="$emit('close')" append-to-body>
		<!-- 今日操作区 -->
		<div class="myatt-today">
			<div class="info">
				<div class="d">{{ todayText }}</div>
				<div class="st" :class="'st-' + (myStatus == null ? 'none' : myStatus)">{{ statusText }}</div>
			</div>
			<div class="ops">
				<el-button type="success" size="small" :disabled="myStatus !== null || punching" @click="doPunch()">
					<i class="el-icon-alarm-clock"></i> 打卡</el-button>
				<el-button type="warning" size="small" plain @click="showLeave = !showLeave">
					<i class="el-icon-edit-outline"></i> 请假</el-button>
			</div>
		</div>
		<!-- 请假表单 -->
		<div class="myatt-leave" v-if="showLeave">
			<el-date-picker v-model="leaveDate" type="date" size="mini" value-format="yyyy-MM-dd"
				format="yyyy-MM-dd" placeholder="请假日期" style="width:150px"></el-date-picker>
			<el-select v-model="leaveType" size="mini" style="width:100px">
				<el-option :value="2" label="请假"></el-option>
				<el-option :value="3" label="半天假"></el-option>
			</el-select>
			<el-input v-model="leaveRemark" size="mini" placeholder="请假原因" style="width:160px"></el-input>
			<el-button size="mini" type="primary" :loading="leaving" @click="doLeave()">提交</el-button>
		</div>
		<!-- 我的月度日历 -->
		<div class="myatt-cal" v-loading="calLoading">
			<div class="cal-toolbar">
				<el-button size="mini" icon="el-icon-arrow-left" @click="shiftMonth(-1)"></el-button>
				<span class="m">{{ month }}</span>
				<el-button size="mini" icon="el-icon-arrow-right" @click="shiftMonth(1)"></el-button>
				<span class="spacer"></span>
				<span class="sum">出勤 {{ calSum.normal }} · 请假 {{ calSum.leave }} · 半天假 {{ calSum.half }} · 休息 {{ calSum.rest }} · 待确认 {{ calSum.pending }}</span>
			</div>
			<div class="cal-head">
				<span v-for="w in ['一', '二', '三', '四', '五', '六', '日']" :key="w">周{{ w }}</span>
			</div>
			<div class="cal-grid">
				<div v-for="(c, i) in calCells" :key="i" :class="['cal-cell', c.cls || 'blank']" :title="c.remark || ''">
					<template v-if="c.date">
						<span class="d">{{ c.day }}</span>
						<span class="t">{{ c.tag }}</span>
					</template>
				</div>
			</div>
			<div class="legend">
				<span><i class="dot ok"></i>上班</span>
				<span><i class="dot leave"></i>请假</span>
				<span><i class="dot half"></i>半天假</span>
				<span><i class="dot off"></i>休息</span>
				<span><i class="dot pending"></i>待确认</span>
				<span><i class="dot rest"></i>休息日</span>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import bizApi from "../../api/bizApi.js";

export default {
	name: "chatMyAttDialog",
	props: {
		visible: { type: Boolean, default: false }
	},
	data() {
		return {
			myStatus: null,
			punching: false,
			showLeave: false,
			leaveDate: this.fmtDay(new Date()),
			leaveType: 2,
			leaveRemark: '',
			leaving: false,
			month: this.fmtMonth(new Date()),
			calLoading: false,
			cal: { days: [], restDays: [] }
		}
	},
	computed: {
		todayText() {
			const d = new Date();
			return d.getFullYear() + '年' + (d.getMonth() + 1) + '月' + d.getDate() + '日';
		},
		statusText() {
			if (this.myStatus === null) return '今日未打卡';
			if (this.myStatus === 0) return '已打卡，待管理员确认';
			if (this.myStatus === 1) return '今日考勤：正常';
			if (this.myStatus === 2) return '今日考勤：请假';
			if (this.myStatus === 3) return '今日考勤：半天假';
			if (this.myStatus === 4) return '今日考勤：休息';
			return '';
		},
		calSum() {
			const s = { normal: 0, leave: 0, half: 0, pending: 0, rest: 0 };
			(this.cal.days || []).forEach(d => {
				if (d.status === 1) s.normal++;
				else if (d.status === 2) s.leave++;
				else if (d.status === 3) s.half++;
				else if (d.status === 0) s.pending++;
				else if (d.status === 4) s.rest++;
			});
			return s;
		},
		calCells() {
			const cells = [];
			if (!this.month) return cells;
			const p = this.month.split('-');
			const y = +p[0], m = +p[1];
			const lead = (new Date(y, m - 1, 1).getDay() + 6) % 7;
			const daysInMonth = new Date(y, m, 0).getDate();
			const map = {};
			(this.cal.days || []).forEach(d => { map[d.date] = d; });
			const rests = {};
			(this.cal.restDays || []).forEach(d => { rests[d] = true; });
			for (let i = 0; i < lead; i++) cells.push({ date: null });
			for (let d = 1; d <= daysInMonth; d++) {
				const date = this.month + '-' + ('0' + d).slice(-2);
				const rec = map[date];
				let cls = rests[date] ? 'rest' : 'none';
				let tag = rests[date] ? '休' : '';
				if (rec) {
					if (rec.status === 1) { cls = 'ok'; tag = '班'; }
					else if (rec.status === 2) { cls = 'leave'; tag = '假'; }
					else if (rec.status === 3) { cls = 'half'; tag = '半'; }
					else if (rec.status === 4) { cls = 'off'; tag = '休'; }
					else { cls = 'pending'; tag = '待'; }
				}
				cells.push({ date, day: d, cls, tag, remark: rec && rec.remark ? date + ' ' + rec.remark : '' });
			}
			return cells;
		}
	},
	watch: {
		visible(v) {
			if (v) {
				this.month = this.fmtMonth(new Date());
				this.leaveDate = this.fmtDay(new Date());
				this.showLeave = false;
				this.loadToday();
				this.loadCal();
			}
		}
	},
	methods: {
		loadToday() {
			bizApi.attMyToday().then((d) => {
				this.myStatus = d && d.status != null ? d.status : null;
			}).catch(() => { });
		},
		loadCal() {
			if (!this.month) return;
			this.calLoading = true;
			bizApi.attMyCalendar(this.month).then((d) => {
				this.cal = d || { days: [], restDays: [] };
			}).catch(() => { }).finally(() => { this.calLoading = false; });
		},
		shiftMonth(n) {
			const p = this.month.split('-');
			const d = new Date(+p[0], +p[1] - 1 + n, 1);
			this.month = this.fmtMonth(d);
			this.loadCal();
		},
		doPunch() {
			this.punching = true;
			bizApi.attPunch().then((d) => {
				this.$message.success((d && d.message) || '打卡成功');
				this.loadToday();
				this.loadCal();
				this.$emit('changed');
			}).catch((e) => this.$message.error((e && e.message) || '打卡失败')).finally(() => { this.punching = false; });
		},
		doLeave() {
			if (!this.leaveDate) {
				this.$message.warning('请选择请假日期');
				return;
			}
			this.leaving = true;
			bizApi.attLeave({ date: this.leaveDate, status: this.leaveType, remark: this.leaveRemark }).then(() => {
				this.$message.success('已提交请假：' + this.leaveDate);
				this.showLeave = false;
				this.leaveRemark = '';
				this.loadToday();
				this.loadCal();
				this.$emit('changed');
			}).catch((e) => this.$message.error((e && e.message) || '请假失败')).finally(() => { this.leaving = false; });
		},
		fmtDay(d) {
			return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
		},
		fmtMonth(d) {
			return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2);
		}
	}
};
</script>

<style lang="scss" scoped>
.myatt-today {
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: #f5f7fa;
	border-radius: 8px;
	padding: 12px 16px;
	margin-bottom: 12px;

	.info {
		.d {
			font-size: 13px;
			color: #909399;
		}

		.st {
			font-size: 16px;
			font-weight: 600;
			margin-top: 4px;

			&.st-none { color: #606266; }
			&.st-0 { color: #e6a23c; }
			&.st-1 { color: #67c23a; }
			&.st-2, &.st-3 { color: #f56c6c; }
			&.st-4 { color: #5b7bb2; }
		}
	}
}

.myatt-leave {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 12px;
	padding: 10px 12px;
	background: #fdf6ec;
	border-radius: 6px;
}

.myatt-cal {
	.cal-toolbar {
		display: flex;
		align-items: center;
		gap: 8px;
		margin-bottom: 8px;

		.m {
			font-size: 14px;
			font-weight: 600;
			color: #303133;
			min-width: 70px;
			text-align: center;
		}

		.spacer { flex: 1; }

		.sum {
			font-size: 12px;
			color: #606266;
		}
	}

	.cal-head {
		display: grid;
		grid-template-columns: repeat(7, 1fr);
		gap: 5px;
		margin-bottom: 5px;

		span {
			text-align: center;
			font-size: 12px;
			color: #909399;
		}
	}

	.cal-grid {
		display: grid;
		grid-template-columns: repeat(7, 1fr);
		gap: 5px;
	}

	.cal-cell {
		height: 52px;
		border-radius: 6px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border: 1px solid #ebeef5;
		background: #fff;

		.d {
			font-size: 13px;
			font-weight: 600;
		}

		.t {
			font-size: 10px;
			margin-top: 2px;
		}

		&.blank {
			border-color: transparent;
			background: transparent;
		}

		&.ok {
			background: #67c23a;
			border-color: #67c23a;
			color: #fff;
		}

		&.leave {
			background: #fdecec;
			border-color: #f6c1c1;
			color: #e05a5a;
		}

		&.half {
			background: #fdf6ec;
			border-color: #f5dab1;
			color: #e6a23c;
		}

		&.pending {
			background: #fff8e6;
			border-color: #ffe9a8;
			color: #d4a017;
		}

		&.rest {
			background: #f2f3f5;
			border-color: #e4e7ed;
			color: #909399;
		}

		&.off {
			background: #eef3fa;
			border-color: #c6d9f5;
			color: #5b7bb2;
		}

		&.none {
			color: #c0c4cc;
		}
	}

	.legend {
		display: flex;
		gap: 12px;
		margin-top: 10px;
		font-size: 12px;
		color: #606266;

		.dot {
			display: inline-block;
			width: 10px;
			height: 10px;
			border-radius: 3px;
			margin-right: 4px;
			vertical-align: -1px;

			&.ok { background: #67c23a; }
			&.leave { background: #f6c1c1; }
			&.half { background: #f5dab1; }
			&.pending { background: #ffe9a8; }
			&.off { background: #c6d9f5; }
			&.rest { background: #e4e7ed; }
		}
	}
}
</style>
